import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrangeToBack = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M4.986 12.351a.5.5 0 0 1 .716-.697L7.5 13.502V4.777a.5.5 0 0 1 1 0v8.724l1.798-1.848a.5.5 0 0 1 .716.697l-2.656 2.73a.5.5 0 0 1-.716 0l-2.656-2.73ZM6 10.732l-3.88-1.94a1 1 0 0 1 0-1.789l.95-.475-.95-.476a1 1 0 0 1 0-1.789l5.21-2.605a1.5 1.5 0 0 1 1.34 0l5.21 2.605a1 1 0 0 1 0 1.79l-.95.475.95.475a1 1 0 0 1 0 1.79L10 10.732V9.613l3.433-1.716L10 6.18V5.063l1.811.906 1.622-.811-5.21-2.605a.5.5 0 0 0-.447 0l-5.21 2.605 1.623.81L6 5.064v1.118L2.567 7.898l-.448.894.448-.894L6 9.614v1.118Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default ArrangeToBack
